import type { UseDisclosureReturn } from '@talos/kyoko';
import { ButtonVariants, Dialog, Flex } from '@talos/kyoko';

export function RemoveSpaceDialog({
  label = '',
  ...props
}: {
  label: string | undefined;
  onConfirm: () => void;
} & UseDisclosureReturn) {
  return (
    <Dialog
      title={`Removing "${label}" space`}
      variant={ButtonVariants.Negative}
      width={360}
      confirmLabel="Remove space"
      cancelLabel="Cancel"
      dataTestId="remove-space-dialog"
      stretchButtons={true}
      {...props}
    >
      <Flex flexDirection="column" gap="spacing12">
        <div>You are about to remove the &quot;{label}&quot; space.</div>
        <div>Would you like to proceed?</div>
      </Flex>
    </Dialog>
  );
}
